/* eslint-disable react/require-default-props */
import React from "react";
import DependencyValidator from "../dependency-validator";

import { Container } from "./styles";

type IProps = any & {
  childrenComponent?: any;
  text?: string;
};

const Warning: React.FC<IProps> = ({
  text,
  childrenComponent,
  ...el
}: IProps) => (
  <DependencyValidator {...el}>
    <Container {...el}>{text ? <p>{text}</p> : childrenComponent()}</Container>
  </DependencyValidator>
);

export default Warning;
